import { Check } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import PriceTable from "@/components/PriceTable";
import CTASection from "@/components/CTASection";
import ZWImage from "@/components/ZWImage";
import { GARTEN_ROWS, HINWEISE } from "@/data/services";

const FALLBACK =
  "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Gartenservice() {
  return (
    <>
      <SEO
        title="Gartenservice Herten – Preise & Leistungen | ZWILLINGSWERK"
        description="Gartenpflege in Herten + 20 km: Rasen mähen ab 0,18 €/m², Heckenschnitt 5,00 €/lfm, Gartenpflege-Abo ab 99 €/Monat. Alle Preise netto & brutto transparent."
      />
      <PageHero
        eyebrow="Gartenservice · Privat & Gewerbe"
        title="Pflege. Gestaltung. Lebensqualität."
        description="Wir kümmern uns um Ihren Garten – zuverlässig, professionell und mit Liebe zum Detail. Ob regelmäßige Pflege oder einmalige Reinigung: Ihr grünes Paradies ist bei uns in besten Händen."
        testid="garten-hero"
      />

      <section className="py-14 bg-[#F8FAF8] border-b border-[#D7E5D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8 space-y-6">
              <PriceTable
                title="Gartenservice & Außenanlagen"
                subtitle="Rasen, Hecke, Baumpflege & Saisonabos – alle Preise netto & brutto"
                badge="Privat & Gewerbe"
                rows={GARTEN_ROWS}
                footnote="Entsorgung von Grünschnitt & Abfällen nach Aufwand. Anfahrt 20 km inklusive."
                testid="price-table-garten"
              />
              <div className="bg-white border border-[#D7E5D9] rounded-xl p-5 text-xs text-[#5D7761] space-y-2" data-testid="garten-legal-notes">
                <p>
                  <strong className="text-[#122B18]">Gut zu wissen:</strong> Garten- und Landschaftsbau ist kein
                  zulassungspflichtiges Handwerk. Baumfällungen und größere Baumarbeiten führen wir nur über einen
                  Fachbetrieb durch. Pflanzenschutzmittel setzen wir nur mit Sachkundenachweis ein.
                </p>
                <p>
                  Heckenschnitt und starke Rückschnitte richten sich nach dem Bundesnaturschutzgesetz (1. März – 30.
                  September beachten).
                </p>
              </div>
            </div>

            <aside className="lg:col-span-4 space-y-6">
              <ZWImage
                src="/images/gartenservice.png"
                fallback={FALLBACK}
                alt="Heckenschnitt in einem gepflegten Garten in Herten durch ZWILLINGSWERK"
                className="w-full aspect-[4/3] rounded-2xl shadow-lg"
                subcaption="Gartenservice"
                caption="Saubere Kanten, gesunde Hecken"
                testid="garten-image"
              />
              <div className="bg-[#122B18] text-white rounded-2xl p-6 space-y-4">
                <h2 className="text-lg font-black font-display">Beliebt bei unseren Kunden</h2>
                <ul className="space-y-2.5 text-sm text-[#D7E5D9]">
                  {[
                    "Gartenpflege-Abo ab 99 €/Monat netto",
                    "Frühjahrs- & Herbstputz zum Stundensatz",
                    "Heckenschnitt zum fairen Meterpreis",
                    "Rasenpflege inkl. Vertikutieren & Nachsaat",
                  ].map((t) => (
                    <li key={t} className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-[#A3D9A5] shrink-0 mt-0.5" /> {t}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-white border border-[#D7E5D9] rounded-2xl p-6 space-y-3 text-xs text-[#4A634E]">
                <h3 className="text-sm font-bold text-[#122B18] uppercase tracking-wider">Wichtige Hinweise</h3>
                <p>{HINWEISE.mindest}</p>
                <p>{HINWEISE.anfahrt}</p>
                <p>{HINWEISE.zahlung}</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
